import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import get from 'lodash/get';

import { SEPARATOR_STROKE } from '../../../constants';
import { shouldTruncate } from '../../../utils/truncate-text';

import { HorizontalDashes } from '../../common/dashes'
import KeyValueListRow from './key-value-list-row';

import styles, { defaultColumnWidths } from './key-value-list-view.styles';

function KeyValueListView(props) {
  const {
    detailsGroups,
    row,
    renderFirstSeparator,
    renderLastSeparator,
    widths,
    defaultCurrency,
    screen,
    messages,
  } = props;

  function hasShortDescription(group) {
    return !group.some(({ key, type }) =>
      type === 'description' && !shouldTruncate(get(row, key)));
  }
  return (
    <View testID="details">
      { detailsGroups
        .filter(hasShortDescription)
        .map((group, index) => (
          <View testID="details-group" key={index}>
            { group.map(({ isTablet, isPhone }, j) => {
              const dashRow = (
                <View key={j}>
                  <HorizontalDashes stroke={SEPARATOR_STROKE} />
                </View>
              );
              if (screen.isSmall && isPhone) {
                if (j === 0 && (index !== 0 || renderFirstSeparator)) {
                  return dashRow;
                }
              }
              if (!screen.isSmall && isTablet) {
                if (j === 0 && (index !== 0 || renderFirstSeparator)) {
                  return dashRow;
                }
              }
            } ) }
            { group.map(({ label, key, type, minimumFractionDigits, maximumFractionDigits, isTablet, isPhone }, i) => {
              const detailRow = (
                <KeyValueListRow
                  label={messages[label]}
                  value={get(row, key)}
                  unit={get(row, `${key}Unit`) || defaultCurrency}
                  type={type}
                  key={label || i}
                  widths={widths}
                  isPhone={isPhone}
                  isTablet={isTablet}
                  minimumFractionDigits={minimumFractionDigits}
                  maximumFractionDigits={maximumFractionDigits}
                  messages={messages}
                />
              );
              if (screen.isSmall && isPhone) {
                return detailRow;
              }
              if (!screen.isSmall && isTablet) {
                return detailRow;
              }
            } ) }
          </View>
      ) ) }
      { renderLastSeparator &&
        <View>
          <HorizontalDashes stroke={SEPARATOR_STROKE} />
        </View>
      }
    </View>
  );
}

KeyValueListView.propTypes = {
  detailsGroups: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  }))),
  row: PropTypes.object,
  renderFirstSeparator: PropTypes.bool,
  renderLastSeparator: PropTypes.bool,
  widths: PropTypes.arrayOf(PropTypes.number),
  defaultCurrency: PropTypes.string,
  screen: PropTypes.shape({
    isSmall: PropTypes.bool,
  }),
};

KeyValueListView.defaultProps = {
  renderFirstSeparator: true,
  renderLastSeparator: true,
  widths: [0.6, 0.4],
  screen: {
    isSmall: false,
  },
};

export default pure(KeyValueListView);
